import { ageBucket } from "@/lib/format";
import { cn } from "@/lib/utils";

type Props = {
  days: number;
  /** Affiche "Xj" plutôt que "0–30j". Défaut : true. */
  withDays?: boolean;
};

export function AgeBadge({ days, withDays = true }: Props) {
  const b = ageBucket(days);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 py-[3px] px-2 rounded-full text-[12px] font-semibold tabular-nums whitespace-nowrap",
        b.badgeClass,
      )}
    >
      {withDays ? `${days}j` : b.label}
    </span>
  );
}
